import { StyledProps, React, withStyles } from '@api';
import { LinearProgress } from '@material-ui/core'

const styles = {
  root: {
    position: 'absolute',
    top: 0,
    zIndex: 2000,
    height: 1,
    width: '100%'
  }
}

interface MyProps extends StyledProps {
}

@(withStyles as any)(styles)
export class ProgressBar extends React.Component <MyProps> {
  render() {
    const {classes} = this.props
    return (
      <div className={classes.root}>
        <LinearProgress color={'secondary'}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/ProgressBar.tsx